import { render, staticRenderFns } from "./FeatureCardFormPrintButton.vue?vue&type=template&id=2a0b9aee&"
import script from "./FeatureCardFormPrintButton.vue?vue&type=script&lang=js&"
export * from "./FeatureCardFormPrintButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports